import React from 'react';

interface SalesforceIconProps {
  className?: string;
  size?: number;
}

const SalesforceIcon: React.FC<SalesforceIconProps> = ({ className = "", size = 24 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M8.562 11.068c-.048-.315-.073-.637-.073-.964 0-3.866 3.134-7 7-7 3.247 0 5.974 2.213 6.758 5.218.364-.119.751-.182 1.153-.182 2.209 0 4 1.791 4 4s-1.791 4-4 4H9c-2.761 0-5-2.239-5-5 0-2.126 1.327-3.938 3.194-4.654.123-.368.368-.418.368-.418z" fill="#00A1E0"/>
      <circle cx="12" cy="8" r="2" fill="white"/>
      <path d="M10.5 8c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5z" fill="#00A1E0"/>
    </svg>
  );
};

export default SalesforceIcon;









